<template>
  <v-card class="flex primaryColor" flat tile>
    <v-card-text class="py-2 white--text text-center">
      &copy; {{ new Date().getFullYear() }} <strong>Le Capteur Français</strong> —
      Développé par <strong>EL OMARI Soufyane</strong> 🔥
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "SFooter",
};
</script>

<style></style>
